var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelpTipCollapse = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 61,
  height: 61,
  viewBox: "0 0 61 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.3496 32.708L30.3496 25.708L37.3496 32.708H23.3496Z",
  fill: "#D2DDEC"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.3
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30.3496,
  cy: 30.3213,
  r: 30,
  fill: "#C0CCDD"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelpTipCollapse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/helpTipCollapse.a6f864aae796c18a744e1ca0b804e2da.svg";